import { Stack, Checkbox, Typography } from "@mui/material";
import useCheckStudentHomework from "../../../Hooks/useCheckStudentHomework";

const statusOptions = [
  { key: "complete", label: "C", color: "green" },
  { key: "incomplete", label: "IC", color: "orange" },
  { key: "late", label: "L", color: "blue" },
  { key: "missing", label: "M", color: "red" },
];

export default function CheckHomework({ editData, setRefetch }) {
  const { handleSubmit } = useCheckStudentHomework({ setRefetch });

  const currentStatus = editData?.status ?? "empty";

  const handleChange = (status) => {
    const newStatus = currentStatus === status ? "empty" : status;

    handleSubmit({
      id: editData?._id,
      status: newStatus,
    });
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2.5}
      justifyContent="center"
    >
      {statusOptions.map(({ key, label, color }) => (
        <Stack direction="row" alignItems="center" key={key}>
          <Checkbox
            checked={currentStatus === key}
            onChange={() => handleChange(key)}
            inputProps={{ "aria-label": `${label} status` }}
            sx={{
              color: color,
              "&.Mui-checked": {
                color: color,
              },
            }}
          />
          <Typography>{label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
